import markUrl from "../../assets/brand/logo-mark.png";
import wordmarkUrl from "../../assets/brand/logo-wordmark.png";
import { cn } from "../../lib/cn";

/** The Scalephant elephant, as a transparent image (the owner's logo, 22.10.2026). */
export const LOGO_MARK_URL = markUrl;

/** The elephant alone. Decorative: the surrounding link or text carries the name. */
export function ElephantMark({ className }: { className?: string }) {
  return <img src={markUrl} alt="" aria-hidden className={cn("object-contain", className)} />;
}

/** Mark plus the logo's wordmark. The name stays real text for the link's accessible name. */
export function Logo({ className, name }: { className?: string; name: string }) {
  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <ElephantMark className="h-8 w-auto shrink-0" />
      <img src={wordmarkUrl} alt="" aria-hidden className="h-4 w-auto" />
      <span className="sr-only">{name}</span>
    </span>
  );
}
